import React, { useEffect, useState } from "react";
import FilterDropdown from "./FilterDropdown";
import useSearchFilter from "hooks/useSearchFilter";
import { useSearchParams } from "react-router-dom";
import { formatBathroomText } from "utils/searchFilter";
import { ReactComponent as BathroomFilterIcon } from "assets/icons/bathroom_filter.svg";
import FilterButton from "components/Buttons/FilterButton";

const bathoomsOptionList = ["1", "2", "3", ">3"];

const BathroomsFilter = () => {
  const { numberOfBathrooms, setNumberOfBathrooms } = useSearchFilter();
  const [bathroomText, setBathroomText] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const urlParams = new URLSearchParams(searchParams.toString());

  const updateSearchParams = (bathroom) => {
    if (bathroom === ">3") {
      urlParams.set("bathroom", 4);
    } else {
      urlParams.set("bathroom", bathroom);
    }
    setSearchParams(urlParams);
  };

  const handleBathroom = (bathroom) => {
    const isSelected =
      numberOfBathrooms === bathroom ||
      (numberOfBathrooms === "4" && bathroom === ">3");

    if (isSelected) {
      setNumberOfBathrooms("");
      setBathroomText("");
      urlParams.delete("bathroom");
    } else {
      setNumberOfBathrooms(bathroom === ">3" ? "4" : bathroom);
      setBathroomText(formatBathroomText(bathroom));
      updateSearchParams(bathroom);
    }
    setSearchParams(urlParams);
  };

  // Initial bathroom value set
  useEffect(() => {
    const initialBathroom = urlParams.get("bathroom") || "";
    setNumberOfBathrooms(initialBathroom);
    setBathroomText(formatBathroomText(initialBathroom));
  }, [searchParams]);

  return (
    <FilterDropdown
      selectedItem={bathroomText}
      id="bathrooms"
      placeholder="Bagni"
      dropdownStyle={{ width: 280 }}
      Icon={BathroomFilterIcon}
    >
      <div className="p-4">
        <ul className="flex items-center justify-between">
          {bathoomsOptionList.map((bathroom) => {
            return (
              <li
                key={bathroom}
                className={`w-[48px] h-[32px] border text-[12px] flex items-center justify-center cursor-pointer rounded-[8px] border-[#F0EFFB]  transition-all duration-300 ease-in ${
                  numberOfBathrooms === bathroom ||
                  (parseFloat(numberOfBathrooms) === 4 && bathroom === ">3")
                    ? "bg-primary text-white "
                    : "text-black bg-transparent hover:bg-[#EAEAEA]"
                }`}
                onClick={() => handleBathroom(bathroom)}
              >
                {bathroom}
              </li>
            );
          })}
        </ul>
      </div>
      <FilterButton />
    </FilterDropdown>
  );
};

export default BathroomsFilter;
